import StatusBadge from "@/components/ui/badge"

export const columns = [
  {
    header: "Code",
    accessorKey: "code",
  },
  {
    header: "Name",
    accessorKey: "name",
  },
  {
    header: "Status",
    cell: ({ row }) => <StatusBadge name={row.original.status_label} />,
  },
]
